import { Button, Col, Modal, Row } from 'antd';
import React, {FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { putDataCall } from 'services/api';
import apiPaths from 'services/apiPaths';
import { IRootReducers } from 'src/reducers';
import { IUser } from 'src/shared/models';
import { customFormatMessage } from 'utils';
import {
  setTermsAccepted,
} from 'src/actions/authActions';
import { useRouter } from 'next/router';
import { staticRoutes } from 'config/routes';

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
    authenticated:
      state.auth.accessToken !== null && state.auth.accessToken !== '',
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      setTermsAccepted,
    },
    dispatch
  );

  interface OwnProps {
    showTermsModal,
    setShowTermsModal,
  };

type TermsModalProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const TermsConditionsModal: FC<TermsModalProps> = ({
  user,
  authenticated,
  setTermsAccepted,
  }) => {
  const { asPath } = useRouter();

  const setTermsValidated = async () => {

    const updatedUser:IUser = {
      ...user,
      termsAccepted: true,
    }
    try{
      await putDataCall({
        dataPath: apiPaths.PROFILE.USER_TERMS_COND,
        data: updatedUser,
        callConfig: {},
      });
      setTermsAccepted(true);
      showTerms();
    } catch(error){
      console.log(error);
    }
  };

  const showTerms = () => {
    if( (asPath === staticRoutes.FOOTER.TERMS || asPath === staticRoutes.FOOTER.PRIVACY_POLICY)) return false;
    else return (authenticated && !user.termsAccepted)
  }


  useEffect(() => {
    showTerms()
  }, [asPath, user])


  return(
    <Modal
      visible={showTerms()}
      closable={false}
      keyboard={false}
      footer={null}
      className='terms-conditions-modal'
      >
      <Row justify='center'>
          <Row justify='center'>
            <div className='text-container-terms-modal'>
              <h3 className='terms-conditions-title'>
                {customFormatMessage('terms-and-conditions.title')}
              </h3>
            </div>
          </Row>
          <Row justify='center'>
            <div  className='text-container-terms-modal'>
              <p className='terms-conditions-subtitle'>
                {customFormatMessage('terms-and-conditions.subtitle-one')}
              </p>
            </div>
          </Row>
          <Button className='terms-conditions-button' onClick={() => setTermsValidated()}>
            <p className='terms-conditions-text-button'>
              {customFormatMessage('terms-and-conditions.button')}
            </p>
          </Button>
      </Row>
    </Modal>
  )

}



export default connect(mapStateToProps, mapDispatchToProps)(TermsConditionsModal);
